import { Button } from '@/ui/button/Button';

/** Ghost, bordered team-dialog footer button (Cancel / Done). */
export function ModalGhostButton({
  children,
  ...props
}: Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'>) {
  return (
    <Button type="button" variant="secondary" size={8} {...props}>
      {children}
    </Button>
  );
}
